// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
    --gutter: 2.4rem;
    --color-neutrals-background-zebra: rgba(0,0,0,0.05);
    --color-neutrals-borderBeta: rgba(0,0,0,0.1);
    --border-radius-large: 1.6rem;
    --color-neutrals-textBeta: rgba(0,0,0,0.6);
    --color-neutrals-background: rgba(0,0,0,0.02);
    --color-warn-epsilon: rgba(255, 235, 59, 1);
    --color-warn-beta: rgba(255, 193, 7, 1);
    --color-fail-gamma: rgba(244, 67, 54, 0.3);
    --color-fail-alpha: rgba(244, 67, 54, 1);
}

.FAC3i0UY5JLwWkMgbYJ_ {
    color: rgba(232, 63, 63, 1) !important;
}

.QWe76DbJTGwnq1HQLK4K {
    margin-left: calc(var(--gutter) / -3);
    margin-top: 0.2em;
    line-height: 0;
}

.tX1kP0w7jzD1DGLIy4lN {
    font-size: 1.6rem;
    position: relative;
}

.tX1kP0w7jzD1DGLIy4lN > svg {
    position: absolute;
    right: 0;
    top: 0;
    transform: translateY(30%);
}

.cMUMpzMKJUPCRubMtnm5 {
    grid-column: 2 / -1;
    border-top: 1px solid var(--color-neutrals-borderBeta);
    margin-top: calc(var(--gutter) / 2);
    padding-top: calc(var(--gutter) / 2);
}

.cMUMpzMKJUPCRubMtnm5 > div {
    display: flex;
    margin-bottom: calc(var(--gutter) / 4);
    gap: 0.5ch;
}

.bySL9FszzwKzM3X_BFMf .label {
    color: var(--color-neutrals-textBeta);
    margin-bottom: calc(var(--gutter) / 2);
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.bySL9FszzwKzM3X_BFMf > div {
    padding: calc(var(--gutter) / 2) 0;
}

.WxooG4IRF3ak4MlO9iGz {
    font-weight: bold;
    display: inline-flex;
    align-items: center;
    line-height: 0;
}

.WxooG4IRF3ak4MlO9iGz svg {
    margin: 0 0.5ch 0 0.2em;
}

.WxooG4IRF3ak4MlO9iGz.WOAGcHrmMiwZRL3fTSPi {
    color: var(--color-fail-alpha);
}

/* DeviceEvent styles */
.TUZiFZ9T0NZcd45DVzGG {
    border-radius: var(--border-radius);
    padding: calc(var(--gutter) / 4) calc(var(--gutter) / 1.5);
}

.TUZiFZ9T0NZcd45DVzGG._ekfsIfmvUB09jTR6NQa {
    cursor: pointer;
}

.TUZiFZ9T0NZcd45DVzGG.ubjsf2FiQfTNQlAMf7ap {
    background-color: var(--color-neutrals-background);
    border: 2px solid var(--color-neutrals-borderBeta);
}

.TUZiFZ9T0NZcd45DVzGG.ysWP6iDkVas9IWfG4O5u {
    background-color: var(--color-warn-epsilon);
    border: 2px solid var(--color-warn-beta);
}

.TUZiFZ9T0NZcd45DVzGG.GY2UMda7JlmiEQT0oJwF {
    background-color: var(--color-fail-epsilon);
    border: 2px solid var(--color-fail-beta);
}

.Y8v0PpYhtGBSKRDdatNz {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.R8jz8KpwhJRweOt_dcXo {
    display: flex;
    align-items: center;
}

.GmayRoMpFnu30_iabbRx {
    margin-right: calc(var(--gutter) / 2);
}

.IZtLj7nL9KFTitdMaX8U {
    margin-top: calc(var(--gutter) / 2);
    border-top: 1px solid var(--color-fail-gamma);
    padding-top: calc(var(--gutter) / 3);
}
`, "",{"version":3,"sources":["webpack://./pages/Organizations/EnterpriseMemberDetails/DeviceLogLineItem/style.module.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;IAChB,mDAAmD;IACnD,4CAA4C;IAC5C,6BAA6B;IAC7B,0CAA0C;IAC1C,6CAA6C;IAC7C,2CAA2C;IAC3C,uCAAuC;IACvC,0CAA0C;IAC1C,wCAAwC;AAC5C;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,qCAAqC;IACrC,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,MAAM;IACN,0BAA0B;AAC9B;;AAEA;IACI,mBAAmB;IACnB,sDAAsD;IACtD,mCAAmC;IACnC,oCAAoC;AACxC;;AAEA;IACI,aAAa;IACb,sCAAsC;IACtC,UAAU;AACd;;AAEA;IACI,qCAAqC;IACrC,sCAAsC;IACtC,aAAa;IACb,mBAAmB;IACnB,8BAA8B;AAClC;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,iBAAiB;IACjB,oBAAoB;IACpB,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,8BAA8B;AAClC;;AAEA,uBAAuB;AACvB;IACI,mCAAmC;IACnC,0DAA0D;AAC9D;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,kDAAkD;IAClD,kDAAkD;AACtD;;AAEA;IACI,2CAA2C;IAC3C,wCAAwC;AAC5C;;AAEA;IACI,2CAA2C;IAC3C,wCAAwC;AAC5C;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,mCAAmC;IACnC,6CAA6C;IAC7C,oCAAoC;AACxC","sourcesContent":[":root {\n    --gutter: 2.4rem;\n    --color-neutrals-background-zebra: rgba(0,0,0,0.05);\n    --color-neutrals-borderBeta: rgba(0,0,0,0.1);\n    --border-radius-large: 1.6rem;\n    --color-neutrals-textBeta: rgba(0,0,0,0.6);\n    --color-neutrals-background: rgba(0,0,0,0.02);\n    --color-warn-epsilon: rgba(255, 235, 59, 1);\n    --color-warn-beta: rgba(255, 193, 7, 1);\n    --color-fail-gamma: rgba(244, 67, 54, 0.3);\n    --color-fail-alpha: rgba(244, 67, 54, 1);\n}\n\n.alert {\n    color: rgba(232, 63, 63, 1) !important;\n}\n\n.caretIcon {\n    margin-left: calc(var(--gutter) / -3);\n    margin-top: 0.2em;\n    line-height: 0;\n}\n\n.logLineItem {\n    font-size: 1.6rem;\n    position: relative;\n}\n\n.logLineItem > svg {\n    position: absolute;\n    right: 0;\n    top: 0;\n    transform: translateY(30%);\n}\n\n.lineItemDetails {\n    grid-column: 2 / -1;\n    border-top: 1px solid var(--color-neutrals-borderBeta);\n    margin-top: calc(var(--gutter) / 2);\n    padding-top: calc(var(--gutter) / 2);\n}\n\n.lineItemDetails > div {\n    display: flex;\n    margin-bottom: calc(var(--gutter) / 4);\n    gap: 0.5ch;\n}\n\n.replacementDetails :global(.label) {\n    color: var(--color-neutrals-textBeta);\n    margin-bottom: calc(var(--gutter) / 2);\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n}\n\n.replacementDetails > div {\n    padding: calc(var(--gutter) / 2) 0;\n}\n\n.returnedStatus {\n    font-weight: bold;\n    display: inline-flex;\n    align-items: center;\n    line-height: 0;\n}\n\n.returnedStatus svg {\n    margin: 0 0.5ch 0 0.2em;\n}\n\n.returnedStatus.notReturned {\n    color: var(--color-fail-alpha);\n}\n\n/* DeviceEvent styles */\n.deviceEventCard {\n    border-radius: var(--border-radius);\n    padding: calc(var(--gutter) / 4) calc(var(--gutter) / 1.5);\n}\n\n.deviceEventCard.expandable {\n    cursor: pointer;\n}\n\n.deviceEventCard.info {\n    background-color: var(--color-neutrals-background);\n    border: 2px solid var(--color-neutrals-borderBeta);\n}\n\n.deviceEventCard.warning {\n    background-color: var(--color-warn-epsilon);\n    border: 2px solid var(--color-warn-beta);\n}\n\n.deviceEventCard.error {\n    background-color: var(--color-fail-epsilon);\n    border: 2px solid var(--color-fail-beta);\n}\n\n.deviceEventHeader {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n}\n\n.deviceEventTitle {\n    display: flex;\n    align-items: center;\n}\n\n.deviceEventCaretIcon {\n    margin-right: calc(var(--gutter) / 2);\n}\n\n.deviceEventExpandedContent {\n    margin-top: calc(var(--gutter) / 2);\n    border-top: 1px solid var(--color-fail-gamma);\n    padding-top: calc(var(--gutter) / 3);\n}\n"],"sourceRoot":""}]);
// Exports
export var alert = `FAC3i0UY5JLwWkMgbYJ_`;
export var caretIcon = `QWe76DbJTGwnq1HQLK4K`;
export var logLineItem = `tX1kP0w7jzD1DGLIy4lN`;
export var lineItemDetails = `cMUMpzMKJUPCRubMtnm5`;
export var replacementDetails = `bySL9FszzwKzM3X_BFMf`;
export var returnedStatus = `WxooG4IRF3ak4MlO9iGz`;
export var notReturned = `WOAGcHrmMiwZRL3fTSPi`;
export var deviceEventCard = `TUZiFZ9T0NZcd45DVzGG`;
export var expandable = `_ekfsIfmvUB09jTR6NQa`;
export var info = `ubjsf2FiQfTNQlAMf7ap`;
export var warning = `ysWP6iDkVas9IWfG4O5u`;
export var error = `GY2UMda7JlmiEQT0oJwF`;
export var deviceEventHeader = `Y8v0PpYhtGBSKRDdatNz`;
export var deviceEventTitle = `R8jz8KpwhJRweOt_dcXo`;
export var deviceEventCaretIcon = `GmayRoMpFnu30_iabbRx`;
export var deviceEventExpandedContent = `IZtLj7nL9KFTitdMaX8U`;
export default ___CSS_LOADER_EXPORT___;
